/**
 * Adds thousands separators to the integer part of a number represented as a string.
 * Note: This function does not truncate decimals. For 1234.56 it returns '1 234.56'.
 *
 * @param value The number or string to format.
 * @returns A formatted string. Returns '' for null, undefined, or non-numeric inputs.
 */
export const addThousandsSeparators = (
  value: number | string | null | undefined
): string => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  // Convert to string, remove ALL spaces, and standardize decimal separator
  const cleanedString = String(value).replace(/\s/g, '').replace(',', '.');

  // Check if it's a valid number after cleaning.
  // parseFloat is used for its lenient parsing.
  // If it's not a number (e.g., 'abc', or just spaces which become ''), return empty string.
  if (isNaN(parseFloat(cleanedString))) {
    return '';
  }

  // Separate integer and decimal parts
  const parts = cleanedString.split('.');
  const integerPart = parts[0];
  const decimalPart = parts.length > 1 ? `.${parts[1]}` : '';

  // Format the integer part with thousands separators
  const formattedIntegerPart = integerPart.replace(
    /\B(?=(\d{3})+(?!\d))/g,
    ' '
  );

  // Combine and return
  return formattedIntegerPart + decimalPart;
};
